import VideoJsAdapter from '../../adapters/videojs_adapter';
import Button from '../button';

export default class Index extends Button {
  buildCSSClass() {
    return 'vjs-episodes-list-button vjs-control vjs-button';
  }

  handleClick(e){
    e.stopPropagation();
    this.player().trigger({ type: 'toggle-episode-chooser', data: { event: e } });
  }

  createEl() {
    const el = super.createEl();
    el.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><path d="M14.797 11.586h10.926c1.629 0 2.937 0 4 .086 3.875.312 6.64 3.164 6.953 6.95.086 1.062.086 2.37.086 4v10.925c0 1.629 0 2.937-.086 4-.32 3.875-3.168 6.64-6.953 6.95-1.063.089-2.371.089-4 .089H14.797c-1.625 0-2.938 0-4-.09-3.871-.316-6.64-3.164-6.95-6.95-.085-1.062-.085-2.37-.085-4V22.622c0-1.629 0-2.937.086-4 .316-3.875 3.164-6.64 6.949-6.95 1.062-.085 2.375-.085 4-.085Zm.586 11.293C15 23.406 15 24.32 15 26.14v3.882c0 1.825 0 2.739.383 3.262 1.207 1.66 3.129.262 4.422-.492l3.343-1.941c1.067-.711 2.73-1.184 2.782-2.7.05-1.515-1.684-2.199-2.782-2.836l-3.343-1.941c-1.293-.754-3.215-2.152-4.422-.496Zm0 0" style="stroke:none;fill-rule:evenodd;fill:#fff;fill-opacity:1"/><path d="M12.398 5.602c0-1.106.899-2 2-2h20.364c5.52 0 10 4.476 10 10v18.953a1.999 1.999 0 1 1-4 0V13.602c0-3.317-2.688-6-6-6H14.398c-1.101 0-2-.899-2-2Zm0 0" style="stroke:none;fill-rule:evenodd;fill:#fff;fill-opacity:1"/></svg>
    `;
    return el;
  }
}

Index.prototype.controlText_ = 'Open Episodes List';
VideoJsAdapter.registerComponent('VpEpisodesListButton', Index);
